/// <reference path="Main.js" />
/// <reference path="Enumeration-vsdoc.js" />

/* global InputNotifier */

function InputNotifierSepaAbo(options) {
	$.extend(this, options);
	const self = this;
	self._init();
}

InputNotifierSepaAbo.prototype = new InputNotifier();

InputNotifierSepaAbo.prototype.meldung = function (value) {
	const field = $(`#ValidationMessageId_${this.Id}`);
	field.html(value);
	field.removeClass('field-validation-error').addClass('field-validation-message');
};

InputNotifierSepaAbo.prototype.error = function (value) {
	const field = $(`#ValidationMessageId_${this.Id}`);
	field.html(value);
	field.removeClass('field-validation-message').addClass('field-validation-error');
};
